"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extra = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ContainerTokens = function (type) {
    return "\n  bg-alias-color-bg-alt\n  border-alias-color-border-base\n  h-component-extra-height\n  px-component-extra-padding\n  rounded-component-extra-border-radius\n  flex\n  items-center\n  justify-center\n  ".concat(type === 'strong' ? 'border-[1px]' : 'border-[0px]', "\n  ");
};
var LabelTokens = "\n  text-alias-color-text-weaker\n  text-[0.875rem]\n  font-medium\n  tracking-alias-font-label-weak-letter-spacing\n  font-alias-font-label-weak-font-family\n";
/**
 * @param {'weak' | 'strong'} type type of label, weak has no border, strong has 1 px border.
 * @param {string} label text inside container
 */
var Extra = function (props) {
    var type = props.type, label = props.label, dataTestID = props["data-testid"];
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: ContainerTokens(type), "data-testid": dataTestID }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: LabelTokens }, { children: label })) })));
};
exports.Extra = Extra;
